import { AiFillCaretRight, AiOutlinePause, AiOutlinePoweroff } from 'react-icons/ai';
export const JobStatus = ['Open', 'On Hold', 'Closed'];

export const JobStatusMap = {
	'Open': 'green',
	'On Hold': 'gold',
	'Closed': 'volcano'
};

export const jobStatusIconMap = {
	'Open': <AiFillCaretRight />,
	'On Hold': <AiOutlinePause />,
	'Closed': <AiOutlinePoweroff />
};
